export default __webpack_public_path__ + "static/media/amulet-transparent.bd8d7312.svg";